import { CrmtDecoder } from "./crmt-decoder";
import { CrmtEncoder } from "./crmt-encoder";
import { CrmtFile, CrmtHeader, ICrmtFile } from "./crmt-file";

export interface StandardPhonebookItem {
    number: string;
    index: number;
    description: string;
}

export class StandardPhonebook extends CrmtFile implements ICrmtFile {

    public entries: StandardPhonebookItem[] = [];

    constructor(public header: CrmtHeader) {
        super()
    }

    public static fromRawData(buffer: ArrayBuffer): StandardPhonebook {
        
        const decoder = new CrmtDecoder(buffer);

        // Extract the common header values
        const header = decoder.getHeader()

        // Create the new object
        const thingy = new StandardPhonebook(header);

        // Extract the actual entries
        const entryCount = decoder.getUint32();

        for(let e = 0; e < entryCount; e++) {

            const index = decoder.getUint16();
            const number = decoder.getLengthEncodedAscii();
            const description = decoder.getLengthEncodedUtf();
    
            thingy.addEntry(index, number, description);
        }

        return thingy;
    }

    public toRawData(): ArrayBuffer {

        const encoder = new CrmtEncoder(100 * 1024)

        // // Create the header
        encoder.setHeader(this.header)

        // Write the actual entries
        const entryCount = this.entries.length
        encoder.setUint32(entryCount);

        const entries: StandardPhonebookItem[] = []

        for(let e = 0; e < entryCount; e++) {

            const entry = this.entries[e]
            encoder.setUint16(entry.index);
            encoder.setLengthEncodedAscii(entry.number);
            encoder.setLengthEncodedUtf(entry.description);
        }

        return encoder.getFileData()
    }

    public addEntry(
        index: number,
        number: string,
        description: string): void {

        const entry: StandardPhonebookItem = {
            index,
            number,
            description
        }    

        this.entries.push(entry)
    }
}
